(function(){
  var sizes=document.getElementById('sizes'), price=document.getElementById('price'), plab=document.getElementById('pricelab');
  var vid=document.getElementById('variant-id');
  function pick(btn){
    [].forEach.call(sizes.children,function(b){b.setAttribute('aria-pressed',String(b===btn));});
    price.firstChild.nodeValue=btn.dataset.p;
    plab.textContent=btn.dataset.ft;
    if(vid) vid.value=btn.dataset.vid;
    // keep the Ask the gallery panel on the chosen height
    var em=document.querySelector('[data-enq-meta]'), epc=document.querySelector('[data-enq-piece]');
    if(em) em.textContent=btn.dataset.ft+' · '+btn.dataset.p;
    if(epc) epc.value=epc.getAttribute('data-title')+', '+btn.dataset.ft;
  }
  sizes.addEventListener('click',function(e){var b=e.target.closest('button'); if(b)pick(b);});
  pick(sizes.querySelector('[aria-pressed="true"]'));
  var v=document.getElementById('video');
  v.addEventListener('click',function(){
    var f=document.createElement('iframe'), ok=false;
    f.src='https://www.youtube-nocookie.com/embed/'+v.dataset.vid+'?autoplay=1&rel=0';
    f.title='York\u2019s Shona Gallery Presents: The Giraffe';
    f.allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen=true;
    f.addEventListener('load',function(){ok=true;});
    v.replaceChildren(f);
    setTimeout(function(){
      if(ok) return;
      var a=document.createElement('a');
      a.href='https://www.youtube.com/watch?v=' + v.dataset.vid;
      a.target='_blank'; a.rel='noopener'; a.className='video__blocked';
      a.innerHTML='This preview cannot embed video.<br><u>Open the film on YouTube</u>';
      v.replaceChildren(a);
    },2500);
  },{once:true});
  var thumbs=document.getElementById('thumbs'), hero=document.getElementById('hero');
  thumbs.addEventListener('click',function(e){
    var b=e.target.closest('button'); if(!b)return;
    hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=b.dataset.src;
    [].forEach.call(thumbs.children,function(x){x.setAttribute('aria-current',String(x===b));});
  });
})();
